import { useTheme } from '@mui/material';

export const BenefitQuestionsIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                clipPath="url(#a)"
            >
                <path d="M42 9.333a2.334 2.334 0 0 1 2.333 2.334V19M14 9.333a2.334 2.334 0 0 0-2.333 2.334v35A2.333 2.333 0 0 0 14 49h28a2.333 2.333 0 0 0 2.333-2.333V41.5" />
                <path d="M28 32.667V31.5a1.167 1.167 0 0 1 1.167-1.167 3.5 3.5 0 0 0 3.5-3.5v0a3.5 3.5 0 0 0-3.5-3.5h-3.5m7-9.333h-9.334A2.333 2.333 0 0 1 21 11.667V9.333A2.333 2.333 0 0 1 23.333 7h9.334A2.333 2.333 0 0 1 35 9.333v2.334A2.333 2.333 0 0 1 32.667 14Zm-4.784 25.667h.234" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h56v56H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
